import { ITextMessageTemplate } from "./interfaces/text-message-template";

export class TextMessageTemplate implements ITextMessageTemplate {
  textMessageTemplateId: number;
  textMessageTypeId: number;
  text: string;
  index: number;
  isDeleted: boolean;

  isValid(): boolean {
    throw new Error("Method not implemented.");
  }

  prepare(): void {
    throw new Error("Method not implemented.");
  }
}
